module.exports = __webpack_public_path__ + "media/images/pardavimai-df44c2ed.svg";